const routes = [

	//---- My Profile
	{
		path: '/my-profile',
		name: "my-profile",
		component: () => import("/my-profile/index.vue"),
		meta: { layout: "primary", module: "myProfile", parentRouteName: "", pageTitle: "Profile", kbFile: "my-profile", kbTitle: "My Profile" }
	},
	{
		path: '/help/what-lotus-captures',
		name: "what-lotus-captures",
		component: () => import("/my-profile/what-lotus-captures.vue"),
		meta: { layout: "primary", module: "myProfile", parentRouteName: "my-profile", pageTitle: "What Lotus captures", kbFile: "my-profile", kbTitle: "My Profile" }
	},
	{
		// The reader's own record of the system messages Lotus has sent them, reached from
		// their name in the sidebar. Lives under /my-profile because it is personal to them,
		// not an administration surface.
		path: '/my-profile/messages',
		name: "my-profile-messages",
		component: () => import("/system-messages/my-messages.vue"),
		meta: { layout: "primary", module: "myProfile", parentRouteName: "my-profile", pageTitle: "Messages", kbFile: "my-profile", kbTitle: "My Profile" }
	},
	{
		path: '/my-location',
		name: "my-location",
		component: () => import("/my-profile/my-location.vue"),
		meta: { layout: "primary", module: "myProfile", parentRouteName: "", pageTitle: "My Location", kbFile: "my-location", kbTitle: "My Location" } 
	},

]


export default routes;